import React, { useEffect } from "react";
import {
    Box,
    Container,
    Typography,
    Grid,
    Card,
    CardContent,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Button,
    Stack,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import FormularioNichos from "./components/FormularioNichos";


export default function GamerStreamer() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <>
            <Header />
            <Box sx={{ background: "#fff", marginTop: 2 }}>
                {/* HERO */}
                <Box
                    sx={{
                        position: "relative",
                        overflow: "hidden",
                        py: { xs: 10, md: 18 },
                        background: `
                            radial-gradient(circle at top left, rgba(156,1,185,0.12), transparent 40%),
                            radial-gradient(circle at bottom right, rgba(30,255,134,0.10), transparent 40%),
                            #FFFFFF
                        `,
                    }}
                >
                    {/* Glow Roxo */}
                    <Box
                        sx={{
                            position: "absolute",
                            width: 450,
                            height: 450,
                            background: "#9C01B9",
                            opacity: 0.08,
                            borderRadius: "50%",
                            filter: "blur(120px)",
                            top: -150,
                            left: -150,
                        }}
                    />

                    {/* Glow Verde */}
                    <Box
                        sx={{
                            position: "absolute",
                            width: 400,
                            height: 400,
                            background: "#1EFF86",
                            opacity: 0.08,
                            borderRadius: "50%",
                            filter: "blur(120px)",
                            bottom: -150,
                            right: -100,
                        }}
                    />

                    <Container maxWidth="lg">
                        <Stack
                            spacing={4}
                            alignItems="center"
                            textAlign="center"
                            sx={{
                                position: "relative",
                                zIndex: 2,
                            }}
                        >
                            {/* Badge */}
                            <Box
                                sx={{
                                    px: 2,
                                    py: 1,
                                    borderRadius: "999px",
                                    background: "rgba(156,1,185,0.08)",
                                    border: "1px solid rgba(156,1,185,0.15)",
                                    backdropFilter: "blur(10px)",
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontSize: 14,
                                        fontWeight: 700,
                                        color: "#9C01B9",
                                    }}
                                >
                                    ESPECIALISTAS EM GAMERS & STREAMERS
                                </Typography>
                            </Box>

                            {/* Título */}
                            <Typography
                                component="h1"
                                sx={{
                                    fontWeight: 900,
                                    lineHeight: 1,
                                    letterSpacing: "-0.04em",
                                    maxWidth: 1000,
                                    fontSize: {
                                        xs: "2.8rem",
                                        sm: "4rem",
                                        md: "5.5rem",
                                    },
                                }}
                            >
                                Contabilidade para{" "}
                                <Box
                                    component="span"
                                    sx={{
                                        background:
                                            "linear-gradient(90deg,#9C01B9 0%, #1EFF86 100%)",
                                        WebkitBackgroundClip: "text",
                                        WebkitTextFillColor: "transparent",
                                    }}
                                >
                                    Gamers & Streamers
                                </Box>
                            </Typography>

                            {/* Subtítulo */}
                            <Typography
                                sx={{
                                    maxWidth: 800,
                                    color: "#5A5A5A",
                                    fontWeight: 400,
                                    lineHeight: 1.7,
                                    fontSize: {
                                        xs: "1.05rem",
                                        md: "1.35rem",
                                    },
                                }}
                            >
                                Bits, subs, donates e patrocínios são tributáveis, e a Receita Federal já tem acesso a esses dados via e-Financeira. A ContBlack legaliza sua operação e reduz seu imposto de até 27,5% para a partir de 6%.
                            </Typography>

                            {/* CTA */}
                            <Button
                                size="large"
                                sx={{
                                    px: 5,
                                    py: 2,
                                    borderRadius: "16px",
                                    fontWeight: 800,
                                    fontSize: "1rem",
                                    textTransform: "none",
                                    background:
                                        "linear-gradient(135deg,#9C01B9 0%, #B800D8 100%)",
                                    color: "#FFF",
                                    boxShadow:
                                        "0 20px 40px rgba(156,1,185,0.30)",
                                    transition: ".3s",
                                    "&:hover": {
                                        transform: "translateY(-3px)",
                                        boxShadow:
                                            "0 30px 60px rgba(156,1,185,0.45)",
                                    },
                                }}
                            >
                                Falar com Especialista
                            </Button>

                            {/* Trust Indicators */}
                            <Stack
                                direction={{ xs: "column", sm: "row" }}
                                spacing={3}
                                sx={{
                                    mt: 2,
                                }}
                            >
                                {[
                                    "Atendimento em todo Brasil",
                                    "100% Digital",
                                    "Especialistas no Nicho",
                                ].map((item) => (
                                    <Stack
                                        key={item}
                                        direction="row"
                                        spacing={1}
                                        alignItems="center"
                                    >
                                        <Box
                                            sx={{
                                                width: 10,
                                                height: 10,
                                                borderRadius: "50%",
                                                background: "#1EFF86",
                                                boxShadow:
                                                    "0 0 12px #1EFF86",
                                            }}
                                        />

                                        <Typography
                                            sx={{
                                                color: "#444",
                                                fontWeight: 600,
                                            }}
                                        >
                                            {item}
                                        </Typography>
                                    </Stack>
                                ))}
                            </Stack>
                        </Stack>
                    </Container>
                </Box>

                {/* DORES */}
                <Box
                    sx={{
                        py: { xs: 10, md: 14 },
                        position: "relative",
                        overflow: "hidden",
                        background: "#FAFAFA",
                    }}
                >
                    {/* Glow */}
                    <Box
                        sx={{
                            position: "absolute",
                            width: 500,
                            height: 500,
                            background: "#9C01B9",
                            opacity: 0.05,
                            borderRadius: "50%",
                            filter: "blur(140px)",
                            top: -200,
                            right: -150,
                        }}
                    />

                    <Container maxWidth="lg">
                        {/* Cabeçalho */}
                        <Stack
                            spacing={3}
                            alignItems="center"
                            textAlign="center"
                            sx={{ mb: 8 }}
                        >
                            <Box
                                sx={{
                                    px: 2,
                                    py: 1,
                                    borderRadius: "999px",
                                    background: "rgba(156,1,185,0.08)",
                                    border: "1px solid rgba(156,1,185,0.15)",
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontSize: 13,
                                        fontWeight: 700,
                                        color: "#9C01B9",
                                        letterSpacing: 1,
                                    }}
                                >
                                    PRINCIPAIS DESAFIOS
                                </Typography>
                            </Box>

                            <Typography
                                sx={{
                                    fontWeight: 900,
                                    lineHeight: 1.1,
                                    maxWidth: 900,
                                    fontSize: {
                                        xs: "2rem",
                                        md: "3.5rem",
                                    },
                                }}
                            >
                                Os problemas que mais afetam{" "}
                                <Box
                                    component="span"
                                    sx={{
                                        background:
                                            "linear-gradient(90deg,#9C01B9,#C300E5)",
                                        WebkitBackgroundClip: "text",
                                        WebkitTextFillColor: "transparent",
                                    }}
                                >
                                    gamers e streamers
                                </Box>
                            </Typography>

                            <Typography
                                sx={{
                                    maxWidth: 750,
                                    color: "#666",
                                    fontSize: {
                                        xs: "1rem",
                                        md: "1.15rem",
                                    },
                                    lineHeight: 1.8,
                                }}
                            >
                                A Twitch e outras plataformas de streaming são obrigadas a reportar pagamentos para autoridades fiscais. Um streamer com 3 anos de carreira sem declaração correta pode receber uma notificação de cobrança retroativa com multa de 75% sobre o imposto devido e juros compostos. O risco cresce a cada mês que passa.
                            </Typography>
                        </Stack>

                        {/* Cards */}
                        <Grid container spacing={3} sx={{ justifyContent: "center" }}>
                            {[
                                {
                                    title: "Recebimentos do exterior sem estrutura legal",
                                    description: "Você recebe da Twitch em dólar, mas nunca soube exatamente como declarar esses valores no Brasil.",
                                },
                                {
                                    title: "Tributação de Bits, Subs e Donates",
                                    description: "Bits e donates somam R$3.000, R$5.000 por mês, e você não sabe se precisa declarar ou não.",
                                },
                                {
                                    title: "Dificuldade para fechar patrocínios",
                                    description: "Uma marca de periférico quer fechar patrocínio, mas exige nota fiscal e você não tem CNPJ.",
                                },
                                {
                                    title: "Medo de fiscalização e cobrança retroativa",
                                    description: "Você nunca configurou o Tax Interview da Twitch e não sabe se está sendo taxado corretamente.",
                                },
                                {
                                    title: "CNPJ aberto, mas com atividades erradas",
                                    description: "Sabe que deveria regularizar, mas tem medo do imposto retroativo e fica postergando.",
                                },
                            ].map((item, index) => (
                                <Grid item xs={12} md={4} key={index}>
                                    <Card
                                        sx={{
                                            height: "100%",
                                            width: window.innerWidth < 600 ? "100%" : "300px",
                                            borderRadius: "28px",
                                            background:
                                                "rgba(255,255,255,0.8)",
                                            backdropFilter: "blur(20px)",
                                            border:
                                                "1px solid rgba(0,0,0,0.05)",
                                            boxShadow:
                                                "0 20px 60px rgba(0,0,0,0.06)",
                                            transition: ".35s",
                                            position: "relative",
                                            overflow: "hidden",

                                            "&:hover": {
                                                transform:
                                                    "translateY(-8px)",
                                                boxShadow:
                                                    "0 30px 80px rgba(156,1,185,0.12)",
                                            },

                                            "&:before": {
                                                content: '""',
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                width: "100%",
                                                height: 4,
                                                background:
                                                    "linear-gradient(90deg,#9C01B9,#1EFF86)",
                                            },
                                        }}
                                    >
                                        <CardContent
                                            sx={{
                                                p: 4,
                                            }}
                                        >
                                            {/* Número */}
                                            <Typography
                                                sx={{
                                                    fontSize: "4rem",
                                                    fontWeight: 900,
                                                    color:
                                                        "rgba(156,1,185,0.08)",
                                                    lineHeight: 1,
                                                    mb: 2,
                                                }}
                                            >
                                                0{index + 1}
                                            </Typography>

                                            {/* Ícone */}
                                            <Box
                                                sx={{
                                                    width: 64,
                                                    height: 64,
                                                    borderRadius: "18px",
                                                    background:
                                                        "rgba(156,1,185,0.08)",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    mb: 3,
                                                }}
                                            >
                                                <WarningAmberIcon
                                                    sx={{
                                                        color: "#9C01B9",
                                                        fontSize: 32,
                                                    }}
                                                />
                                            </Box>

                                            <Typography
                                                sx={{
                                                    fontWeight: 800,
                                                    fontSize: "1.3rem",
                                                    mb: 2,
                                                }}
                                            >
                                                {item.title}
                                            </Typography>

                                            <Typography
                                                sx={{
                                                    color: "#666",
                                                    lineHeight: 1.8,
                                                }}
                                            >
                                                {item.description}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    </Container>
                </Box>

                {/* BENEFÍCIOS */}
                <Box
                    sx={{
                        py: { xs: 10, md: 14 },
                        background: "#050505",
                        position: "relative",
                        overflow: "hidden",
                    }}
                >
                    {/* Glow Roxo */}
                    <Box
                        sx={{
                            position: "absolute",
                            width: 500,
                            height: 500,
                            borderRadius: "50%",
                            background: "#9C01B9",
                            opacity: 0.15,
                            filter: "blur(180px)",
                            top: -250,
                            left: -250,
                        }}
                    />

                    {/* Glow Verde */}
                    <Box
                        sx={{
                            position: "absolute",
                            width: 450,
                            height: 450,
                            borderRadius: "50%",
                            background: "#1EFF86",
                            opacity: 0.08,
                            filter: "blur(180px)",
                            bottom: -250,
                            right: -250,
                        }}
                    />

                    <Container maxWidth="lg">
                        {/* Cabeçalho */}
                        <Stack
                            spacing={3}
                            alignItems="center"
                            textAlign="center"
                            sx={{ mb: 8 }}
                        >
                            <Box
                                sx={{
                                    px: 2,
                                    py: 1,
                                    borderRadius: "999px",
                                    background: "rgba(255,255,255,0.05)",
                                    border: "1px solid rgba(255,255,255,0.08)",
                                }}
                            >
                                <Typography
                                    sx={{
                                        color: "#1EFF86",
                                        fontSize: 13,
                                        fontWeight: 700,
                                        letterSpacing: 1,
                                    }}
                                >
                                    A SOLUÇÃO
                                </Typography>
                            </Box>

                            <Typography
                                sx={{
                                    color: "#FFF",
                                    fontWeight: 900,
                                    lineHeight: 1.1,
                                    maxWidth: 900,
                                    fontSize: {
                                        xs: "2rem",
                                        md: "3.5rem",
                                    },
                                }}
                            >
                                Como a{" "}
                                <Box
                                    component="span"
                                    sx={{
                                        background: "#1EFF86",
                                        WebkitBackgroundClip: "text",
                                        WebkitTextFillColor: "transparent",
                                    }}
                                >
                                    Contblack
                                </Box>{" "}
                                ajuda você a crescer com segurança
                            </Typography>

                            <Typography
                                sx={{
                                    color: "rgba(255,255,255,0.7)",
                                    maxWidth: 750,
                                    lineHeight: 1.8,
                                    fontSize: {
                                        xs: "1rem",
                                        md: "1.15rem",
                                    },
                                }}
                            >
                                A ContBlack é a contabilidade que fala a linguagem do streamer. Conhecemos o Tax Interview da Twitch, sabemos como funciona o Xsolla, entendemos a diferença tributária entre bits, subs, donates e patrocínios. Abrimos seu CNPJ com o CNAE 5911-1/99 correto, configuramos o Fator R e garantimos isenção nos recebimentos do exterior.
                            </Typography>
                        </Stack>

                        {/* Benefícios */}
                        <Grid container spacing={4} sx={{ justifyContent: "center" }}>
                            {[
                                {
                                    title: "CNPJ Otimizado para Streamers",
                                    description: "CNPJ com CNAE 5911-1/99 correto para streaming, Fator R planejado para o Anexo III (6%).",
                                    result: "Menos impostos e uma estrutura fiscal preparada para monetizar suas transmissões.",
                                },
                                {
                                    title: "Isenção Fiscal em Receitas Internacionais",
                                    description: "Isenção de ISS, PIS e COFINS nos recebimentos da Twitch, YouTube Gaming e Kick.",
                                    result: "Mais lucro sobre os valores recebidos das plataformas internacionais.",
                                },
                                {
                                    title: "Configuração Correta do Tax Interview",
                                    description: "Orientação para configurar o Tax Interview da Twitch corretamente.",
                                    result: "Evite retenções indevidas e receba seus pagamentos sem surpresas.",
                                },
                                {
                                    title: "Recebimentos Internacionais Simplificados",
                                    description: "Estrutura para receber via Xsolla, PayPal e outros gateways internacionais.",
                                    result: "Receba do exterior com segurança e organização fiscal.",
                                },
                                {
                                    title: "Nota Fiscal para Patrocínios Gamer",
                                    description: "Nota fiscal para contratos de patrocínio com marcas de games e periféricos.",
                                    result: "Mais profissionalismo para fechar parcerias com grandes marcas.",
                                },
                                {
                                    title: "Declaração Segura de Todas as Monetizações",
                                    description: "Declaração correta de bits, subs, donates e patrocínios, sem risco de autuação retroativa.",
                                    result: "Tranquilidade para crescer seu canal sem preocupações com a Receita Federal.",
                                },
                            ].map((item, index) => (
                                <Grid item xs={12} md={4} key={index}>
                                    <Card
                                        sx={{
                                            height: "100%",
                                            width: window.innerWidth < 600 ? "100%" : "300px",
                                            background:
                                                "rgba(255,255,255,0.04)",
                                            backdropFilter: "blur(20px)",
                                            border:
                                                "1px solid rgba(255,255,255,0.08)",
                                            borderRadius: "28px",
                                            position: "relative",
                                            overflow: "hidden",
                                            transition: ".35s",

                                            "&:hover": {
                                                transform:
                                                    "translateY(-8px)",
                                                border:
                                                    "1px solid rgba(30,255,134,0.25)",
                                                boxShadow:
                                                    "0 30px 80px rgba(30,255,134,0.08)",
                                            },

                                            "&::before": {
                                                content: '""',
                                                position: "absolute",
                                                left: 0,
                                                top: 0,
                                                width: 4,
                                                height: "100%",
                                                background:
                                                    "linear-gradient(180deg,#9C01B9,#1EFF86)",
                                            },
                                        }}
                                    >
                                        <CardContent sx={{ p: 4 }}>
                                            <Box
                                                sx={{
                                                    width: 70,
                                                    height: 70,
                                                    borderRadius: "20px",
                                                    background:
                                                        "rgba(30,255,134,0.08)",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    mb: 3,
                                                }}
                                            >
                                                <CheckCircleIcon
                                                    sx={{
                                                        fontSize: 38,
                                                        color: "#1EFF86",
                                                    }}
                                                />
                                            </Box>

                                            <Typography
                                                sx={{
                                                    color: "#FFF",
                                                    fontWeight: 800,
                                                    fontSize: "1.35rem",
                                                    mb: 2,
                                                }}
                                            >
                                                {item.title}
                                            </Typography>

                                            <Typography
                                                sx={{
                                                    color:
                                                        "rgba(255,255,255,0.7)",
                                                    lineHeight: 1.8,
                                                    mb: 3,
                                                }}
                                            >
                                                {item.description}
                                            </Typography>

                                            <Box
                                                sx={{
                                                    borderTop:
                                                        "1px solid rgba(255,255,255,0.08)",
                                                    pt: 2,
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        color: "#1EFF86",
                                                        fontWeight: 700,
                                                        fontSize: ".95rem",
                                                    }}
                                                >
                                                    ✓ {item.result}
                                                </Typography>
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    </Container>
                </Box>

                {/* FAQ */}
                <Box
                    sx={{
                        py: { xs: 10, md: 14 },
                        background: "#FFFFFF",
                        position: "relative",
                        overflow: "hidden",
                    }}
                >
                    <Container maxWidth="md">
                        <Stack
                            spacing={3}
                            alignItems="center"
                            textAlign="center"
                            sx={{ mb: 7 }}
                        >
                            <Box
                                sx={{
                                    px: 2,
                                    py: 1,
                                    borderRadius: "999px",
                                    background: "rgba(156,1,185,0.08)",
                                    border: "1px solid rgba(156,1,185,0.15)",
                                }}
                            >
                                <Typography
                                    sx={{
                                        color: "#9C01B9",
                                        fontSize: 13,
                                        fontWeight: 700,
                                        letterSpacing: 1,
                                    }}
                                >
                                    DÚVIDAS FREQUENTES
                                </Typography>
                            </Box>

                            <Typography
                                sx={{
                                    fontWeight: 900,
                                    lineHeight: 1.1,
                                    fontSize: {
                                        xs: "2rem",
                                        md: "3.5rem",
                                    },
                                }}
                            >
                                Perguntas que recebemos com frequência
                            </Typography>

                            <Typography
                                sx={{
                                    color: "#666",
                                    maxWidth: 700,
                                    lineHeight: 1.8,
                                }}
                            >
                                Separamos as principais dúvidas sobre contabilidade,
                                tributação e regularização para gamers e streamers.
                            </Typography>
                        </Stack>

                        {[
                            {
                                question: "A Twitch reporta meus ganhos para a Receita Federal?",
                                answer: "Sim, via e-Financeira. Todos os pagamentos internacionais acima de determinados limites são notificados às autoridades fiscais brasileiras.",
                            },
                            {
                                question: "Como funciona o CNAE 5911-1/99 para streamers?",
                                answer: "É o CNAE de atividades de produção cinematográfica e videofonográfica, o mais adequado para streaming, que permite enquadramento no Anexo III do Simples Nacional.",
                            },
                            {
                                question: "Preciso pagar imposto sobre donates?",
                                answer: "Sim. Donates são rendimento tributável. A ContBlack orienta sobre o tratamento correto de cada tipo de receita.",
                            }
                        ].map((item, index) => (
                            <Accordion
                                key={index}
                                disableGutters
                                elevation={0}
                                sx={{
                                    mb: 2,
                                    borderRadius: "20px !important",
                                    overflow: "hidden",
                                    border: "1px solid rgba(0,0,0,0.08)",
                                    boxShadow:
                                        "0 10px 30px rgba(0,0,0,0.04)",

                                    "&:before": {
                                        display: "none",
                                    },
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={
                                        <ExpandMoreIcon
                                            sx={{
                                                color: "#9C01B9",
                                            }}
                                        />
                                    }
                                    sx={{
                                        minHeight: 80,
                                        px: 3,
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: 700,
                                            fontSize: {
                                                xs: "1rem",
                                                md: "1.1rem",
                                            },
                                        }}
                                    >
                                        {item.question}
                                    </Typography>
                                </AccordionSummary>

                                <AccordionDetails
                                    sx={{
                                        px: 3,
                                        pb: 3,
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            color: "#666",
                                            lineHeight: 1.8,
                                        }}
                                    >
                                        {item.answer}
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                        ))}

                        {/* CTA Final */}
                        <Box
                            sx={{
                                mt: 6,
                                p: 4,
                                borderRadius: "24px",
                                background:
                                    "linear-gradient(135deg, rgba(156,1,185,0.05), rgba(30,255,134,0.05))",
                                border: "1px solid rgba(156,1,185,0.08)",
                                textAlign: "center",
                            }}
                        >
                            <Typography
                                sx={{
                                    fontWeight: 800,
                                    fontSize: {
                                        xs: "1.2rem",
                                        md: "1.5rem",
                                    },
                                    mb: 1,
                                }}
                            >
                                Ainda ficou com alguma dúvida?
                            </Typography>

                            <Typography
                                sx={{
                                    color: "#666",
                                    mb: 3,
                                }}
                            >
                                Converse com um especialista e receba uma orientação
                                personalizada para sua situação.
                            </Typography>

                            <Button
                                sx={{
                                    background: "#9C01B9",
                                    color: "#FFF",
                                    px: 4,
                                    py: 1.5,
                                    borderRadius: "14px",
                                    fontWeight: 700,

                                    "&:hover": {
                                        background: "#83009A",
                                    },
                                }}
                            >
                                Falar com Especialista
                            </Button>
                        </Box>
                    </Container>
                </Box>

                <FormularioNichos nicho="Gamer & Streamer" />

                {/* FOOTER */}
                <Footer />
            </Box>
        </>
    );
}